import { useQuery } from '@tanstack/react-query';
import type { AuditGroup, OrgAuditActors, OrgAuditRow, Paged } from '@repo/shared-types';
import { fetchApi } from '../lib/api';

/** Filters of Cài đặt › Nhật ký thao tác. `'all'` means "no filter" for the
 *  two selects; empty strings mean "no bound" for the dates (`YYYY-MM-DD`,
 *  read server-side in Vietnam wall-clock time). */
export interface OrgAuditFilters {
  group: AuditGroup | 'all';
  /** A member's userId, `platform`, `system`, or `all`. */
  actor: string;
  from: string;
  to: string;
  page: number;
  pageSize: number;
}

export function buildOrgAuditUrl(f: OrgAuditFilters): string {
  const q = new URLSearchParams();
  if (f.group !== 'all') q.set('group', f.group);
  if (f.actor !== 'all') q.set('actor', f.actor);
  if (f.from) q.set('from', f.from);
  if (f.to) q.set('to', f.to);
  q.set('page', String(f.page));
  q.set('pageSize', String(f.pageSize));
  return `/audit?${q.toString()}`;
}

export function useOrgAudit(filters: OrgAuditFilters) {
  return useQuery<Paged<OrgAuditRow>>({
    queryKey: ['audit', filters],
    queryFn: () => fetchApi(buildOrgAuditUrl(filters)),
    placeholderData: (prev) => prev,
  });
}

export function useOrgAuditActors() {
  return useQuery<OrgAuditActors>({
    queryKey: ['audit', 'actors'],
    queryFn: () => fetchApi('/audit/actors'),
  });
}
